<template>
  <div data-layout="settings">
    <NuxtLoadingIndicator />
    <NuxtLayout name="dashboard">
      <template #app-footer>
        <CoreAppFooterBlock />
      </template>

      <div class="flex min-h-[60vh] flex-col items-center">
        <slot />
      </div>
    </NuxtLayout>
  </div>
</template>
